import React from "react";

const Divider = ({
  accent = "default",
  padding = false,
  extraTopPadding = false,
}) => {
  return (
    <div
      className={`${padding ? "px-6" : ""} my-6  ${extraTopPadding ? "pt-12 xl:pt-0" : ""}`}
    >
      <div
        className={`border-b-2 ${{ default: "border-b-neutral-200", primary: "border-b-primary-500", secondary: "border-b-neutral-500" }[accent]}`}
      ></div>
    </div>
  );
};

export default Divider;
